import { IEnvironment } from './environment.interface';

export const Environment:IEnvironment = {
  environmentName: 'Development Environment',
  appDomain: 'dev.tenfour.org',
  apiEndpoint: 'https://api.dev.tenfour.org',
  clientId: "1",
  clientSecret: "T7913s89oGgJ478J73MRHoO2gcRRLQ",
  intercomAppId: "hnmleyf3",
  segmentAppId: "zyqqcTkGmM",
  segmentApiKey: "ieZYKiegj7ctbK38BqQKPIwaCommytok",
  firebaseSenderId: '804609537189',
  firebaseProjectId: "tenfour-7322f",
  firebaseAppId: '1:804609537189:web:2d7be5b938d60162',
  firebaseApiKey: "AIzaSyB2oFSjaXf-7dkwNPa_8QsHHn600apSMck",
  sentryDSN: ''
};



// WEBPACK FOOTER //
// ./src/environments/environment.development.ts